import React from "react";
import { useNavigate } from "react-router-dom";
import {
  ArrowIcon,
  FacebookIcon,
  WhatshappIcon,
  YoutubeIcon,
} from "../icons";
import logoFooter from "../assets/logo/logo_footer.png";
import { useNavigation } from "../context/NavigationContext";

const companyLinks = [
  { name: "Meet Our Team", href: "company/team" },

  { name: "About Us", href: "/about" },
  { name: "Contact Us", href: "company/contact" },
];

const infoLinks = [
  { name: "Franchise", href: "/franchise" },
  { name: "FAQs", href: "company/faqs" },
  { name: "Terms & Conditions", href: "company/terms" },
  { name: "Privacy Policy", href: "company/privacy-policy" },
  { name: "Warranty Policy", href: "company/warranty-policy" },
  { name: "Warranty Claim", href: "company/warranty-claim" },
];



const FooterLinkColumn: React.FC<{
  title: string;
  links: { name: string; href: string }[];
}> = ({ title, links }) => {
  const navigate = useNavigate();
  const { setActiveNav } = useNavigation();

  const handleNavigation = (link: { name: string; href: string }) => {
    setActiveNav(link.name);
    navigate(link.href);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };



  return (
    <div className="w-full sm:w-1/2 md:w-auto  md:mt-0">
      <h3 className="text-base sm:text-lg font-bold mb-4 border-b border-white/50 inline-block pb-1">
        {title}
      </h3>
      <ul className="space-y-2">
        {links.map((link) => (
          <li key={link.name} className="flex items-center">
            <ArrowIcon className="w-3.5 h-3.5 mr-2 fill-white" />
            <button
              onClick={() => handleNavigation(link)}
              className="text-white text-sm hover:text-blue-200 transition-colors duration-200 text-left"
            >
              {link.name}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

const CONTAINER_MAX_WIDTH = "max-w-7xl";
const CONTAINER_PADDING = "px-4 sm:px-4 py-1 sm:py-2";
const AppFooter: React.FC = () => {
  return (
    <footer className="bg-[radial-gradient(circle_at_center,_#36C05B_0%,_#35A854_100%)] text-white pt-6">
      <div className={`mx-auto ${CONTAINER_MAX_WIDTH} ${CONTAINER_PADDING}`}>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-8 text-sm">
          <div className="flex flex-col space-y-4 pt-4 md:pt-10">
            <img
              src={logoFooter}
              alt="PhoneLab Logo"
              className="w-32 object-contain"
            />
            <p className="text-white/90 leading-relaxed text-sm max-w-xs">
              Smartphone Repair offers fast, reliable, and professional device
              repairs. From screen replacements to battery fixes, we ensure
              top-quality service with expert care.
            </p>
          </div>

          <FooterLinkColumn title="Information" links={infoLinks} />

          <FooterLinkColumn title="Company" links={companyLinks} />

          <div className="w-full sm:mt-4 md:mt-0">
            <h3 className="text-base sm:text-lg font-bold mb-4">
              Subscribe to our newsletters
            </h3>

            <form className="space-y-3 bg-white/95 p-4 shadow-sm w-full sm:w-[90%] md:w-[85%] lg:w-[300px] xl:w-[280px] mx-auto md:mx-0">
              <input
                type="email"
                placeholder="Enter a valid email address"
                className="w-full p-2  text-gray-800 border-gray-400 focus:blue-600 focus:ring-2 focus:outline-none text-sm"
                required
              />
              <button
                type="submit"
                className="w-full brand-bg brand-bg-hover text-white  font-semibold py-2.5 transition-colors duration-200 text-sm"
              >
                Subscribe Now
              </button>
            </form>

            <div className="flex space-x-3 mt-5 mb-2 sm:justify-center justify-center">
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center bg-white rounded-full brand-text hover:bg-blue-100 transition duration-200"
              >
                <FacebookIcon className="w-4 h-4 brand-fill" />
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center bg-white rounded-full brand-text hover:bg-blue-100 transition duration-200"
              >
                <WhatshappIcon className="w-4 h-4 brand-fill" />
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center bg-white rounded-full brand-text hover:bg-blue-100 transition duration-200"
              >
                <YoutubeIcon className="w-4 h-4 brand-fill" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* -------- COPYRIGHT BAR -------- */}
      <div className="brand-bg shadow-md shadow-[#35A854] py-3 mt-6">
        <div className="max-w-6xl mx-auto px-4 flex justify-center md:justify-between items-center text-xs text-white/90">
          <p>©Copyright 2025. Design by PhoneLab</p>
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
